import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { IFormControl } from '@interfaces/create-form-modal.interface';
import { BsModalRef } from 'ngx-bootstrap/modal';

import { BaseForm } from '../base-form.abstract';

@Component({
  selector: 'app-create-form-modal',
  templateUrl: './create-form-modal.component.html',
})
export class CreateFormModalComponent extends BaseForm implements OnInit {
  @Output() override valueChanges: EventEmitter<Record<string, unknown>> = new EventEmitter();
  @Input() formControls: IFormControl[];
  @Input() headerKey: string;

  otherValidatorsExist: boolean;

  constructor(readonly modalRef: BsModalRef) {
    super();
  }

  ngOnInit(): void {
    this.createForm();
  }

  private createForm(): void {
    this.formControls.forEach((formItem) => {
      const { formControlName, value } = formItem;
      this.form.addControl(formControlName, new UntypedFormControl(value));
      this.setValidators(formItem);
    });
  }

  private setValidators(formItem: IFormControl): void {
    const { formControlName, required, otherValidators } = formItem;
    this.otherValidatorsExist = !!otherValidators.length;

    const arrDependOnRequired = required ? [Validators.required] : [];
    const arrDependOnOtherValidators = this.otherValidatorsExist
      ? [...arrDependOnRequired, ...otherValidators.map((val) => val.fn)]
      : [...arrDependOnRequired];

    this.form.controls[formControlName].setValidators(arrDependOnOtherValidators);
    this.form.controls[formControlName].updateValueAndValidity();
  }
}
